// Pure data — RSC-safe (no styled-components/react imports).
// Only these 40 countries are allowed to access rare/buy pages
export const ALLOWED_RARE_COUNTRIES = [
  'us',
  'ca',
  'vi',
  'sg',
  'kr',
  'th',
  'hk',
  'cn',
  'jp',
  'au',
  'nz',
  'id',
  'fj',
  'de',
  'gb',
  'it',
  'fr',
  'be',
  'dk',
  'se',
  'no',
  'fi',
  'ie',
  'cz',
  'at',
  'pl',
  'ch',
  'lu',
  'nl',
  'gr',
  'es',
  'si',
  'ro',
  'ae',
  'sa',
  'kw',
  'za',
  'ke',
  'in',
  'sx',
  'pa',
];
